import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';

import React, { useEffect, useState, useRef } from 'react';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import { useAlert } from '../../components/alertContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';
import DescriptionIcon from '@mui/icons-material/Description';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { ToastMessage } from '../../Models/ToastMessage';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DrawIcon from '@mui/icons-material/Draw';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';

import { downloadFile } from '../../utils/storageUtil';
import shiftStore from './shiftStore';
const CrewPack: React.FC = () => {
  const menuItems = [
    {
      name: 'Shift Report',
      icon: <DescriptionIcon />,
    },
    {
      name: 'Toolbox Sign Off',
      icon: <DrawIcon />,
    },
    {
      name: 'Photos',
      icon: <PhotoLibraryIcon />,
    },
    {
      name: 'Documents',
      icon: <FileCopyIcon />,
    },
    {
      name: 'SWMS',
      icon: <LibraryAddCheckIcon />,
    },
    {
      name: 'Site Memo',
      icon: <EventAvailableIcon />,
    },
    {
      name: 'Notes',
      icon: <InsertDriveFileIcon />,
    },
    {
      name: 'Mobile Prestarts',
      icon: <PhonelinkRingIcon />,
    },
  ];
  const isInitialLoad = useRef(true);

  const { alert, setAlert } = useAlert();
  const { crewId, shiftId } = useParams<{ crewId: any; shiftId: any }>();
  const [inProgress, setInProgress] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [downloadig, setDownloading] = useState<any>(null);
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const [httpError, setHttpError] = useState<ToastMessage>({
    message: 'Saved Successfully',
    errorColor: 'success',
    open: false,
  });
  const loadData = async () => {
    if (crewId) {
      setInProgress(true);
      setInProgress(false);
    }
  };
  useEffect(() => {
    if (isInitialLoad.current) {
      loadData();
      isInitialLoad.current = false;
    }
  }, [crewId]);
  useEffect(() => {
    if (shiftId) {
      if (!currentRecord) fetchShift(shiftId);
      isInitialLoad.current = false;
    }
  }, [shiftId]);
  const fetchShift = async (shiftId: any) => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        Constants.apiURL + Constants.shiftURL + '/' + shiftId,
        { headers: { Authorization: 'Bearer ' + getAdmin() } }
      );
      if (response.success) {
        setCurrentRecord(response.data);
        shiftStore.setDetails(response.data);
      }
      setInProgress(false);
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setHttpError({
        message: error.message,
        errorColor: 'error',
        open: true,
      });
      setInProgress(false);
    }
  };
  const handleMenuClick = (value: any) => {
    if (value === 'Shift Report') {
      navigate('/schedules/crews-schedule/shift/' + crewId + '/' + shiftId);
    }
    if (value === 'Documents') {
      if (currentRecord)
        navigate(
          '/project-dashboard/project/' +
            currentRecord.projectInternalId +
            '#documents'
        );
    }
    if (value === 'Site Memo') {
      if (currentRecord)
        navigate(
          '/schedules/crews-schedule/shift/' + crewId + '/' + shiftId + '/memo'
        );
    }
    if (value === 'SWMS') {
      fetchSWMSDocument();
    }
    if (value === 'Toolbox Sign Off') {
      toolBoxSignOff();
    }
    if (value === 'Photos') {
      navigate(
        '/schedules/crews-schedule/shift/' + crewId + '/' + shiftId + '/photos'
      );
    }
    if (value === 'Mobile Prestarts') {
      navigate(
        '/schedules/crews-schedule/shift/' + crewId + '/' + shiftId + '/map'
      );
    }
    if (value === 'Notes') {
      navigate(
        '/schedules/crews-schedule/shift/' + crewId + '/' + shiftId + '/note'
      );
    }
  };

  const toolBoxSignOff = async () => {
    try {
      const projectId: any = currentRecord
        ? currentRecord.project.projectInternalId
        : '';
      setInProgress(true);
      setDownloading('Toolbox Sign Off');
      const URL = `${Constants.apiURL}${Constants.documentPDFsURL}/fetchToolBoxPDF/${shiftId}`;
      const response = await HttpServices.get(URL, {
        headers: {
          Authorization: 'Bearer ' + getAdmin(),
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      });
      setInProgress(false);
      setDownloading(null);
      if (response) {
        downloadFile(response, 'toolbox_' + projectId + '_' + shiftId + '.pdf');
        window.open(response.data, '_blank');
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      setDownloading(null);
      // console.log('-----');
      // console.log(error.response.data);
      // console.log('-----');
      setAlert({
        type: 'error',
        message: 'Daily toolbox not found',
        open: true,
      });
      setInProgress(false);
    }
  };
  const fetchSWMSDocument = async () => {
    try {
      const projectId: any = currentRecord
        ? currentRecord.project.projectInternalId
        : '';
      setInProgress(true);
      setDownloading('SWMS');
      const URL = `${Constants.apiURL}${Constants.documentPDFsURL}/projectSWMS/${projectId}`;
      const response = await HttpServices.get(URL, {
        headers: {
          Authorization: 'Bearer ' + getAdmin(),
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      });
      setInProgress(false);
      setDownloading(null);
      if (response) {
        downloadFile(response, 'SWMS_' + projectId + '.pdf');
        window.open(response.data, '_blank');
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      setDownloading(null);
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setInProgress(false);
    }
  };
  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <div
              onClick={() => {
                navigate('/schedules/crews-schedule');
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <UTurnLeftIcon
                sx={{
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
              />
              <Typography>Back</Typography>
            </div>

            {currentRecord && (
              <Paper
                sx={{
                  padding: ' 16px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingTop: '20px',
                    paddingBottom: '20px',
                  }}
                >
                  <Box>
                    <b>
                      {currentRecord.project.projectId +
                        ' ' +
                        currentRecord.project.projectName +
                        ' - ' +
                        currentRecord.siteContactName}
                    </b>
                    <h3 className="ovreview-label">
                      {currentRecord.siteAddress}
                    </h3>
                  </Box>
                  <Box>
                    {' '}
                    <h3 className="ovreview-label">
                      {'Allocated Crew  '}
                      <b style={{ marginLeft: '20px' }}>
                        {currentRecord.crew.name}
                      </b>
                    </h3>
                  </Box>
                </Box>
              </Paper>
            )}
            <Typography
              component={'h6'}
              sx={{ width: '100%', mt: 4, fontWeight: '500' }}
            >
              {'Documents'}
            </Typography>
            <Paper sx={{ width: '100%', mt: 4 }} className="mt-4">
              <Box
                sx={{
                  padding: '24px 16px 16px 16px',
                  mb: 2,
                  display: 'grid',
                  gap: '32px',
                  overflowX: 'scroll',
                }}
              >
                <Box sx={{ width: '100%' }}>
                  {inProgress && (
                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                      <LinearProgress />
                    </Box>
                  )}
                  <Box
                    sx={{
                      padding: '24px 16px 16px 16px',
                      mb: 2,
                      display: 'grid',
                      gap: '32px',
                      overflowX: 'scroll',
                    }}
                  >
                    <List dense={true}>
                      {menuItems.map((item: any, index: any) => {
                        return (
                          <ListItem
                            component={Button}
                            onClick={() => {
                              handleMenuClick(item.name);
                            }}
                            disabled={inProgress}
                            divider={true}
                            secondaryAction={
                              downloadig === item.name ? (
                                <CircularProgress size={30} />
                              ) : (
                                <IconButton edge="end" aria-label="Forward">
                                  <ArrowForwardIosIcon />
                                </IconButton>
                              )
                            }
                          >
                            <ListItemAvatar>
                              <Avatar sx={{ background: '#00F4FF29' }}>
                                {item.icon}
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={item.name} />
                          </ListItem>
                        );
                      })}
                    </List>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </div>
        </div>
      </section>
      <AlertMessageComponent
        type={httpError.errorColor}
        open={httpError.open}
        handleClose={() => {
          setHttpError({ open: false, message: '', errorColor: 'error' });
        }}
        message={httpError.message}
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={() => {
          setAlert({ open: false, message: '', type: 'success' });
        }}
        message={alert.message}
      />
    </Box>
  );
};

export default CrewPack;
